export const ERROR_INFO = 'error-info';
